import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

// External components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Translation
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// APIs
import getDarkWebThreat from "api/darkweb/getDarkWebThreat";
import darkWebThreatManaged from "api/darkweb/darkWebThreatsManaged";

// MUI
import { useMaterialUIController } from "context";

const DarkWebDetails = () => {
  const [data, setData] = useState(null);
  const { t } = useTranslation();
  const { id } = useParams();
  // eslint-disable-next-line
  const [controller, _] = useMaterialUIController();
  const { user } = controller;

  const getData = async () => {
    try {
      const response = await getDarkWebThreat(id);
      setData(response);
    } catch (e) {
      console.log("error --->", e);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* back to the results */}
      <div style={{ marginBottom: "15px" }}>
        <Link className="back-to-results-link" to="/darkweb/">
          {t("dataBreach.back_to_results")}
        </Link>
      </div>
      {/* Title */}
      <h2 className="page-title" style={{ paddingBottom: "30px" }}>
        {data && data.title}
      </h2>

      {/* Box */}
      <div className="boxes-border-radius" style={{ background: "white", padding: "15px" }}>
        {data ? (
          <>
            <dl
              style={{
                fontSize: "16px",
                columnCount: 2,
                columnGap: "20px",
              }}
            >
              {data.threatActor ? (
                <>
                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.threat_actor_name")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.threatActor?.name || "N/A"}</dd>
                </>
              ) : null}

              {data.announcedAt ? (
                <>
                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.announced_at")}</dt>
                  <dd style={{ marginBottom: "15px" }}>
                    {moment(data.announcedAt).format("DD/MM/YYYY")}
                  </dd>
                </>
              ) : null}

              {data.victim ? (
                <>
                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.victim")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.victim?.name || "N/A"}</dd>

                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.victim_nation")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.victim?.country || "N/A"}</dd>

                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.victim_industry")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.victim?.industry || "N/A"}</dd>

                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.victim_url")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.victim?.url || "N/A"}</dd>
                </>
              ) : null}

              <dt style={{ fontWeight: "600" }}>{t("darkWeb.attack_type")}</dt>
              <dd style={{ marginBottom: "15px" }}>{data.incidentType || "N/A"}</dd>

              {data.source ? (
                <>
                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.source_location")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.source?.location || "N/A"}</dd>

                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.source_url")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.source?.url || "N/A"}</dd>
                </>
              ) : null}

              {data.description ? (
                <>
                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.description")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.description}</dd>
                </>
              ) : null}

              {data.intelligence ? (
                <>
                  <dt style={{ fontWeight: "600" }}>{t("darkWeb.intelligence")}</dt>
                  <dd style={{ marginBottom: "15px" }}>{data.intelligence}</dd>
                </>
              ) : null}

              <br />
              <br />
            </dl>
            {data.screenshotUrl ? (
              <>
                <dt style={{ fontWeight: "600" }}>{t("darkWeb.screenshot")}</dt>
                <img src={data.screenshotUrl} alt="screenshot" style={{ maxWidth: "900px" }} />
              </>
            ) : null}
          </>
        ) : null}
      </div>

      {data?.canBeManaged && user && user.role && user.role !== "admin" ? (
        <div style={{}}>
          {!data.managedBy ||
            (data.managedBy && data.managedBy.length < 1) ||
            (data.managedBy &&
              data.managedBy.length > 0 &&
              user &&
              user.id &&
              !data.managedBy.includes(user.id)) ? (
            <button
              type="button"
              className="request-report-button"
              onClick={() => {
                if (data.id) {
                  darkWebThreatManaged(data.id)
                    .then((resManaged) => {
                      if (resManaged && resManaged.managedBy && resManaged.managedBy.length > 0) {
                        const newThreat = { ...data, managedBy: resManaged.managedBy };
                        setData(newThreat);
                      }
                    })
                    .catch((errManaged) => {
                      // eslint-disable-next-line
                      console.log("error setting threat managed", errManaged);
                    });
                }
              }}
            >
              {t("darkWeb.manage")}
            </button>
          ) : (
            <div
              style={{
                padding: "10px",
                border: "1px solid green",
                background: "#e6ffde",
                color: "#399918",
                borderRadius: "12px",
                fontWeight: "600",
              }}
            >
              <span>{t("darkWeb.managed_threat")}</span>
            </div>
          )}
        </div>
      ) : null}
    </DashboardLayout>
  );
};

export default DarkWebDetails;
